export var isNumber = function isNumber(subject) {
  return typeof subject === 'number'
  // is not NaN: `NaN === NaN` => `false`
  && subject === subject;
};
export var isArray = Array.isArray;